<script lang="ts">
	import { real_id } from 'src/helpers/interface_helpers';
	import { format } from 'svelte-i18n';

	import type { Device } from 'src/types/Device';

	import { devices, devices_status } from 'src/stores';

	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import ZWavePairedDeviceCard from './ZWavePairedDeviceCard.svelte';

	import { Alert, Text } from '@Shelly/shelly-design-system';

	import { getPairedZWaveCloudDevices } from 'src/helpers/z_wave_gateway_helpers';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device: Device;

	$: status = $devices_status?.[real_id(device?.id)];
	$: pairedDevices = getPairedZWaveCloudDevices(device, status, $devices);
</script>

<!-- ignoreOfflineState: keep paired cards mounted when gateway status/settings flicker -->
<DeviceViewStateWrapper {device} ignoreOfflineState>
	<div slot="staticTop">
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height" slot="content">
		{#if pairedDevices.length > 0}
			<Text styleType="body-small" class="text-muted mb-s">
				{capFirstChar(
					$format('label_zwave_paired_devices', {
						default: 'Paired Z-Wave devices',
					}),
				)}
			</Text>
			{#each pairedDevices as pairedDevice (pairedDevice.id)}
				{@const listDevice = $devices[pairedDevice.id] || pairedDevice}
				{#if listDevice}
					<div class="mb-s">
						<ZWavePairedDeviceCard device={listDevice} />
					</div>
				{/if}
			{/each}
		{:else}
			<Alert
				type="info"
				isHeadingBold
				heading={capFirstChar(
					$format('alert_heading_zwave_no_paired_devices', {
						default: 'No paired devices',
					}),
				)}
				message={$format('alert_message_zwave_no_paired_devices', {
					default:
						'Z-Wave devices included through this gateway will appear here once they are added to your account.',
				})}
			/>
		{/if}
	</div>
</DeviceViewStateWrapper>
